/* eslint-disable no-shadow */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import BookingLoading from './BookingLoading';
import { attemptBook, setBookingFlowState } from '../../../../../ui-kitchen/src/reducers/bookingSlice';
import { getUserThunk, selectIsConcierge } from '../../../../../ui-kitchen/src/reducers/userSlice';
import { selectIsAuthenticated } from '../../../../../ui-kitchen/src/reducers/authTokenSlice';
import { IDLE } from '../../../../../ui-kitchen/src/constants/asyncLoadingStatuses';
import { SUMMARY } from '../../../../../ui-kitchen/src/constants/bookingFlow';
import { setSearchParams } from '../../../../../ui-kitchen/src/utils/searchParamUtils';

const BookingController = (props) => {
  const {
    attemptBook, getUserThunk, isAuthenticated, isConcierge, loadingBooking, setBookingFlowState,
  } = props;

  useEffect(() => {
    let ignore = false;
    const fetchUserAndAttempt = () => {
      getUserThunk().then((user) => {
        if (!ignore) {
          if (isConcierge) {
            setBookingFlowState(SUMMARY);
          } else {
            attemptBook({
              isAuthenticated,
              cardsOnFile: !!user?.payment_methods?.length,
            });
          }
        }
      });
    };
    if (loadingBooking === IDLE) {
      setSearchParams('next', null);
      fetchUserAndAttempt();
    }
    return () => {
      ignore = true;
    };
  }, []);
  return <BookingLoading />;
};

BookingController.propTypes = {
  attemptBook: PropTypes.func.isRequired,
  getUserThunk: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isConcierge: PropTypes.bool.isRequired,
  loadingBooking: PropTypes.func.isRequired,
  setBookingFlowState: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const isAuthenticated = selectIsAuthenticated(state);
  const isConcierge = selectIsConcierge(state);
  const { booking } = state;
  const { loadingBooking } = booking;
  return {
    isAuthenticated,
    isConcierge,
    loadingBooking,
  };
};

const mapDispatchToProps = {
  attemptBook,
  getUserThunk,
  setBookingFlowState,
};

export { BookingController as ComponentUserTest, mapStateToProps };
export default connect(mapStateToProps, mapDispatchToProps)(BookingController);
